"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartBar = void 0;
/*
 * Copyright (c) 2023 Discover Financial Services
 * Licensed under MIT License. See License.txt in the project root for license information
 */
const molecule_1 = require("./molecule");
const props_1 = require("../common/props");
/**
 * The Chart Bar molecule.
 * @category Molecules
 */
class ChartBar extends molecule_1.Molecule {
    constructor(molecules) {
        super("Bar Chart", molecules);
        this.barBackgroundColor = new props_1.PropertyBackgroundColorStyle("Line Background Color", false, this);
        this.barWidth = new props_1.PropertyPixelSelectable("Bar Width", false, this, [8, 16, 24, 32, 40, 48, 56]);
        this.barRadius = new props_1.PropertyPixelSelectable("Bar Radius", false, this, [0, 4, 8, 16, 24, 32, 40, 48, 56]);
        this.chartBorder = new props_1.PropertyPixelSelectable("Chart Border", false, this, [1, 2, 3, 4]);
        this.barShadow = new props_1.PropertyShadowSelectable("Bar Shadow", false, this);
        this.chartLinesDisplay = new props_1.PropertyBoolean("Chart Lines Display", false, this);
        this.yLabelsDisplay = new props_1.PropertyBoolean("Y Labels Display", false, this);
    }
    deserialize(obj) {
        if (!obj)
            return;
        super.deserialize(obj);
        this.barBackgroundColor.deserialize(obj.barBackgroundColor);
        this.barWidth.deserialize(obj.barWidth);
        this.barRadius.deserialize(obj.barRadius);
        this.chartBorder.deserialize(obj.chartBorder);
        this.barShadow.deserialize(obj.barShadow);
        this.chartLinesDisplay.deserialize(obj.chartLinesDisplay);
        this.yLabelsDisplay.deserialize(obj.yLabelsDisplay);
    }
    serialize() {
        const obj = {};
        obj.barBackgroundColor = this.barBackgroundColor.serialize();
        obj.barWidth = this.barWidth.serialize();
        obj.barRadius = this.barRadius.serialize();
        obj.chartBorder = this.chartBorder.serialize();
        obj.barShadow = this.barShadow.serialize();
        obj.chartLinesDisplay = this.chartLinesDisplay.serialize();
        obj.yLabelsDisplay = this.yLabelsDisplay.serialize();
        return obj;
    }
}
exports.ChartBar = ChartBar;
